<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import GetAFreeEstimate from '$lib/PageSections/GetAFreeEstimate/GetAFreeEstimate.svelte';

	import installationImage from './images/09-indow-windows-copypp_w1600_h1067-1.jpg';
	import heroImage from './images/shutterstock_734672728-1200x801.jpg';
</script>

<Section>
	<Image src={heroImage} loading="eager" />
	<h2 class="text-left">The State of Federal Energy Credits</h2>
	<p class="text-left">
		While the Inflation Reduction Act (IRA) previously offered significant
		savings through the Energy Efficient Home Improvement Tax Credit, the
		federal government has ended this specific tax credit program. However,
		while the federal window of opportunity has closed, there are still many
		ways to save on your home performance upgrades and reduce your monthly
		utility costs.
	</p>

	<h2 class="text-left">Best in Class Pricing & Proven Savings</h2>
	<div
		class="
    mb-10 grid gap-6
    md:grid-cols-2 md:gap-10
  "
	>
		<div>
			<p class="text-left">
				At Indow, we are committed to making home comfort affordable regardless
				of federal policy changes. Indow offers best in class pricing that
				achieves an average of <a href="/solutions/lower-energy-bills"
					>20% annual energy savings</a
				>.
			</p>
			<p class="text-left">
				Beyond the immediate impact on your utility bills, you can save even
				more with bulk discounts when you choose to insulate your entire home.
				Our tiered pricing ensures that the more windows you protect, the more
				you save on your initial investment.
			</p>
		</div>
		<Image
			src={installationImage}
			alt="Indow window insert blocks cold drafts, pollutants, and more by fitting snugly within frames"
		/>
	</div>

	<h2 class="text-left">Explore Local Rebates & Incentives</h2>

	<p class="text-left">
		Even without the federal credit, you may not have to pay full price for your
		energy upgrades. Your state or county may offer additional rebates or tax
		credits for energy efficient home improvements. Many local utility companies
		also provide weatherization incentives that apply to window inserts.
	</p>
	<p class="text-left">
		We encourage you to check your local laws and utility programs to see what
		is available in your area. If you need documentation or specific product
		data to qualify for a local program, let us know and we will be happy to
		provide any assistance.
	</p>
</Section>
<GetAFreeEstimate />
